import "./style.css";
import 'swiper/css';
import 'swiper/css/pagination';
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { failed, success } from "@components/Common/Toastify";
import { forgetPassword } from "../../API/Auth";
import lefticon from "../../Assets/Images/left.png";
import borrowerImg1 from "../../Assets/Images/borrwr-img-one.png";
import borrowerImg2 from "../../Assets/Images/borrwr-img-two.png";
import borrowerImg3 from "../../Assets/Images/borrwr-img-three.png";
import borrowerImg4 from "../../Assets/Images/borrwr-img-four.png";
import borrowerImg5 from "../../Assets/Images/borrwr-img-five.png";
import lenderImg1 from "../../Assets/Images/banner-one.png";
import lenderImg2 from "../../Assets/Images/banner-two.png";
import lenderImg3 from "../../Assets/Images/banner-3.png";
import lenderImg4 from "../../Assets/Images/banner-four.png";
import lenderImg5 from "../../Assets/Images/banner-five.png";
import lendriva_logo from "../../Assets/Images/Lendriva_logo.jpg";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const roleType = location.state?.roleType;
  const [selectedUserType, setSelectedUserType] = useState<
    "borrower" | "lender"
  >("borrower");
  const borrowerImages = [borrowerImg1, borrowerImg2, borrowerImg3, borrowerImg4, borrowerImg5];
  const lenderImages = [lenderImg1, lenderImg2, lenderImg3, lenderImg4, lenderImg5];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);
  const currentBgImage =
    selectedUserType === "borrower"
      ? borrowerImages[currentImageIndex]
      : lenderImages[currentImageIndex];

  useEffect(() => {
    const loginPage = document.querySelector(".onboarding-page");
    if (loginPage) {
      loginPage.classList.remove("theme-borrower", "theme-lender");
      loginPage.classList.add(`theme-${roleType}`);
    }
  }, [roleType]);

  useEffect(() => {
    if (roleType === "borrower" || roleType === "lender") {
      setSelectedUserType(roleType);
    }
  }, [roleType]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(
        (prevIndex) =>
          (prevIndex + 1) %
          (roleType === "borrower"
            ? borrowerImages.length
            : lenderImages.length)
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [roleType]);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
    }),
    onSubmit: (values) => {
      setBtnLoading(true);
      forgetPassword({
        email: values.email.toLowerCase(),
        userType: roleType,
      })
        .then((res: any) => {
          navigate("/auth/reset-password", {
            state: {
              email: values.email.toLowerCase(),
              roleType: roleType,
            },
          });
          success(res?.data?.message);
        })
        .catch((err) => {
          failed(err?.response?.data?.message);
        })
        .finally(() => setBtnLoading(false));
    },
  });

  return (
    <div className="">
      <div className="onboarding-page theme-borrower fg-pw">
        {/* <div className="col-lg-6 bg-image p-0">
          <div className="swiper-inner position-relative">
            <Swiper
              pagination={true}
              modules={[Pagination]}
              className="swiper-block"
              onSlideChange={(swiper) => setCurrentImageIndex(swiper.activeIndex)}
            >
              {(selectedUserType === "borrower" ? borrowerImages : lenderImages).map(
                (imgSrc, index) => (
                  <SwiperSlide key={index}>
                    <div className="slider-images-block">
                      <div className="slider-banner">
                        <img src={imgSrc} alt="" className="img-fluid w-100" />
                      </div>
                      <div className="lendriva-logo-auth position-absolute">
                        <img src={lendriva_logo} alt="" className="img-fluid" />
                      </div>
                      <div className="overlay-content text-center">
                        <h5 className="overlay-heading">Welcome to Lendriva!</h5>
                        <p className="overlay-heading">
                          Empowering Your Financial Journey with Community Support
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                )
              )}
            </Swiper>
          </div>
        </div> */}

        <div className="p-0 d-flex flex-column my-3">
          <div className="upper-div align-items-center d-flex justify-content-between p-0">
            <div className="return-home mb-4">
              <Link
                to="/auth/login"
                state={{ roleType }}
                className="return text-decoration-none"
              >
                <img src={lefticon} alt="back" className="img-fluid back" />
                <span className="ms-2 text-decoration-none">Back</span>
              </Link>
            </div>
          </div>

          <div className="lower-div">
            <div className="credentials-box">
              <div className="heading-para-block">
                <h2 className="text-center">Forget Password</h2>
                <p className="text-center enter-address">
                  Please enter the email address associated with your account.
                </p>
              </div>
              <form className="onboarding-form" onSubmit={formik.handleSubmit}>
                <div className="mb-4">
                  <label htmlFor="email" className="form-label">
                    Email <span className="text-orange">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Email"
                    {...formik.getFieldProps("email")}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-danger small">
                      {formik.errors.email}
                    </div>
                  )}
                </div>
                <button
                  type="submit"
                  className="btn btn-borrower signin w-100"
                  disabled={btnLoading}
                >
                  {btnLoading ? "Sending..." : "Send Reset Code"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
